import React, { Component } from 'react';
import { PanelGroup, Panel } from 'react-bootstrap';
import Loading from './../Loading';
import ConvertibleText from '../ConvertibleText';
import IncludedCheckbox from '../IncludedCoverages';

const Accordion = (WrappedComponent, arrayList, optionalComponent = accordionSuggestionPanel) => {
    class AccordionHOC extends Component {
        constructor(props) {
            super(props);
            this.handleSelect = this.handleSelect.bind(this);
            this.state = {
                activeKey: ''
            };
        }

        handleSelect(activeKey) {
            this.setState({ activeKey });
        }
        render() { 
            const { isModified, name, manuallySetPricing, options, onBlurTextboxHandler } = this.props;
            return (
                <PanelGroup
                    accordion
                    id="accordion-group"
                    activeKey={this.state.activeKey}
                    onSelect={this.handleSelect}
                >
                    {arrayList.map((item, index) => {
                        let hideClass = !!options[index].hideElement ? options[index].hideElement : ""
                        return (
                            <Panel eventKey={index} key={index} className={hideClass}>
                                <Panel.Heading>
                                    <div className="coverage-container">
                                        <div className="row">
                                        {/* ('terror' || 'hnoaPremium' || 'identityrecovery' || 'pollution' || 'subsidence' || 'extendedCompletedOps') */}
                                        {((manuallySetPricing == true) && (options[index].value == 'terror' || options[index].value == 'identityRecovery' || options[index].value == 'hnoaPremium' || options[index].value == 'pollution' || options[index].value == 'subsidence' || options[index].value == 'extendedCompletedOps' || options[index].value == 'bankPremium' || options[index].value == 'additionalInsureds') && (this.props.submission.type == "oi")) ? (
                                                <div className="col-sm-6 col-xs-12">
                                                    <WrappedComponent {...this.props} options={[options[index]]} />
                                                </div>
                                            ) : (
                                                <div className="col-sm-7 col-xs-12">
                                                    <WrappedComponent {...this.props} options={[options[index]]} />
                                                </div>
                                            )}
                                            {isModified ? (
                                                <div className="col-sm-offset-3 col-sm-1 col-xs-10">
                                                    <Loading width="23px" height="23px" />
                                                </div>
                                            ) : options[index].value !== "isPCOpsExcluded" && options[index].value !== "isESWorkExcluded" ? (
                                                <div className="price-values text-right col-sm-4 col-xs-10">
                                                    <ConvertibleText manuallySetPricing={manuallySetPricing} disabled={!options[index].selected || options[index].disable} value={{name: options[index].key, text: options[index].text}} onBlurHandler={onBlurTextboxHandler} /> 
                                                </div>
                                            ) : <div className="price-values text-right col-sm-4 col-xs-10"></div>}
                                            <div className="col-sm-1 col-xs-2">
                                            {options[index].value !== "isESWorkExcluded" ? <Panel.Title toggle /> : ''}
                                            </div>
                                            {manuallySetPricing == true && name !=='baseCoverage' && ((options[index].value == 'hnoaPremium') || (options[index].value == 'pollution') || (index > 2)) ?
                                                <div className = "col-sm-1">
                                                    <IncludedCheckbox {...this.props} options={[options[index]]}/> 
                                                </div> : <div></div>
                                            }
                                        </div>
                                    </div>
                                </Panel.Heading>
                                <Panel.Body collapsible>
                                    {optionalComponent(arrayList[index])}
                                </Panel.Body>
                            </Panel>
                        );
                    })}
                </PanelGroup>
            );
        }
    }
    Accordion.defaultProps = {
        optionalComponent: 'demo'
    };
    return AccordionHOC;
};

const accordionSuggestionPanel = ({ head, subHeader, body, footer, isPCOpsExcluded, isESWorkExcluded }) => {
    return (
        <div className="suggestion-box text-left">
            {head && (
                <div className="mb" style={isPCOpsExcluded && isESWorkExcluded && { marginBottom: "5px"}}>
                    <strong>{head}</strong>:<span className="text-success ml">{subHeader}</span>
                </div>
            )}
            <div dangerouslySetInnerHTML={{ __html: body }} />
            <i>{footer}</i>
        </div>
    );
};

export default Accordion;
